__turbopack_context__.v({
  "className": "inter_d99efeef-module__lVRjuq__className",
});
